import React from "react";
import { StageElement } from "../../../types";
import { StyleActivityTitle, StyleLayoutComponent, StyleLayoutContainer } from "./styles";

type LayoutProps = {
  element: StageElement;
  children: React.ReactNode;
};

const Layout = ({ element, children }: LayoutProps) => {
  const { activityTitle, activityLabel } = element?.config || {};

  return (
    <StyleLayoutContainer className="layout">
      <>
        {(activityTitle || activityLabel) && (
          <StyleActivityTitle className="component-label-section">
            <>
              {activityLabel && (
                <span
                  className="component-label"
                  data-id={`${element.ref}-activityLabel`}
                  dangerouslySetInnerHTML={{ __html: `${activityLabel}` }}
                />
              )}
              {activityTitle && (
                <span
                  className="component-title"
                  data-id={`${element.ref}-activityTitle`}
                  dangerouslySetInnerHTML={{ __html: activityTitle }}
                />
              )}
            </>
          </StyleActivityTitle>
        )}

        <StyleLayoutComponent className="component-container">{children}</StyleLayoutComponent>
      </>
    </StyleLayoutContainer>
  );
};

export default Layout;
